import type { SiteContent } from '../content/types';
import { Container } from '../components/layout/container';
import { PageHero } from '../components/sections/page-hero';
import { ContactCards } from '../components/sections/contact-cards';
import { MapCard } from '../components/sections/map-card';
import { OpeningHoursCard } from '../components/sections/opening-hours-card';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { buildMailto } from '../lib/utils';

interface ContactPageProps {
  content: SiteContent;
}

export function ContactPage({ content }: ContactPageProps): JSX.Element {
  const mailto = buildMailto(content.contact.emailHref, content.contact.mailInquiry.subject, content.contact.mailInquiry.body);

  return (
    <>
      <PageHero title={content.contactPage.heroTitle} text={content.contactPage.heroText}>
        <div className="flex flex-wrap gap-3">
          <Button asChild>
            <a href={mailto}>{content.contact.mailInquiry.label}</a>
          </Button>
          <Button asChild variant="outline">
            <a href={content.contact.phoneHref}>{content.contact.phoneDisplay}</a>
          </Button>
        </div>
      </PageHero>

      <section className="pb-12 sm:pb-16">
        <Container className="grid gap-4 xl:grid-cols-[0.95fr_1.05fr]">
          <div className="space-y-4">
            <ContactCards content={content} />
            <OpeningHoursCard content={content} />
            <Card className="bg-[color:var(--color-surface-alt)]">
              <CardContent className="space-y-2 p-6 text-sm text-[color:var(--color-muted)]">
                <p>{content.contact.practiceName}</p>
                <p>{content.contact.doctorName}</p>
                <p>{`${content.contact.addressLine1}, ${content.contact.postalCode} ${content.contact.city}`}</p>
                <p>{content.contact.country}</p>
              </CardContent>
            </Card>
          </div>

          <MapCard content={content} />
        </Container>
      </section>
    </>
  );
}
